import { satisfiesVersion } from '../directives/versionFeature.js';

export let providesAppVersionPlugin = {
    install(app) {
        app.config.globalProperties.$appVersion = import.meta.env.VITE_APP_VERSION;
        app.config.globalProperties.$meetsVersion = (required) => {
            return satisfiesVersion(import.meta.env.VITE_APP_VERSION, required);
        };
    },
};
